import {
    SET_USERS,
    SET_DETAIL_USER,
    SET_DIALOG_ACTIVE,
    SET_TYPES_IDENTIFICATION,
    SET_GENDERS,
    SET_CIVIL_STATUS,
    SET_TYPES_EPS,
    SET_TYPES_AFP,
    SET_TYPES_ARL,
    SET_TYPES_CCF,
    SET_USER_DETAIL_FIELDS,
    SET_USER_PRODUCT_DETAIL_FIELDS,
    SET_EPS,
    SET_AFP,
    SET_ARL,
    SET_CCF
} from "./types/types";

import { updateField } from "vuex-map-fields";

const mutations = {
    [SET_USERS]: (state, payload) => state.users = payload,
    [SET_DETAIL_USER]: (state, detailUser) => state.detailUser = detailUser,
    [SET_DIALOG_ACTIVE]: (state, { status, index }) => state.users[index]["activeDialogUser"] = status,
    [SET_TYPES_IDENTIFICATION]: (state, payload) => state.typesIdentification = payload,
    [SET_GENDERS]: (state, payload) => state.genders = payload,
    [SET_CIVIL_STATUS]: (state, payload) => state.civilStatus = payload,
    [SET_TYPES_EPS]: (state, payload) => state.listTypesEps = payload,
    [SET_TYPES_AFP]: (state, payload) => state.listTypesAfp = payload,
    [SET_TYPES_ARL]: (state, payload) => state.listTypesArl = payload,
    [SET_TYPES_CCF]: (state, payload) => state.listTypesCcf = payload,
    [SET_USER_DETAIL_FIELDS]: (state, field) => updateField(state.detailUser, field),
    [SET_USER_PRODUCT_DETAIL_FIELDS]: (state, field) => updateField(state.product, field),
    [SET_EPS]: (state, eps) => state.detailUser.eps = eps,
    [SET_AFP]: (state, afp) => state.detailUser.afp = afp,
    [SET_ARL]: (state, arl) => state.detailUser.arl = arl,
    [SET_CCF]: (state, ccf) => state.detailUser.ccf = ccf
};

export default mutations